export default{
  pierwsza_okupacja:{
    cards:[
      {
        id:0,
        img: '/historia/okres_39_41/Wladysław_Kaminski.jpg',
        desc: 'Mjr Władysław Kamiński "Śliwa"'
      },
      {
        id:1,
        img: '/historia/okres_39_41/Henryk_Hlebowicz.jpg',
        desc: 'ks. Henryk Hlebowicz „Bolesław Szewik”'
      },
      {
        id:2,
        img: '/historia/okres_39_41/Nikodem_Sulik.jpg',
        desc: 'Ppłk dypl.Nikodem Sulik „Karol Sarnowski”'
      },
      {
        id:3,
        img: '/historia/okres_39_41/Jozef_Grzesiak.jpg',
        desc: 'Kpt. Józef Grzesiak "Kmita"'
      }
    ],
    list:[
      'Komitet Pomocy Uchodźcom Wojennym - kierowany przez Ignacego Zagórskiego, dr Marię Petrusewiczową i Antoniego Pańskiego.',
      'Komisariat Rządu - kierowany przez Bronisława Świątnickiego „Ojciec” i prof. Rajmunda Gostkowskiego.',
      'Koła Pułkowe - Kierowane przez ppłk Adama Obtułowicza „Karol Podgórski”, „Leon”.',
      'Związek Wolnych Polaków - kierowany przez Jana Kazimierza Mackiewicza.',
      'Komitet Walki o Wyzwolenie - kierowany przez mjr rez. Władysława Kamińskiego „Śliwa”.',
      'Obóz Niepodległości - kierowany przez prof. Witolda Staniewicza.',
      'Organizacja Socjalistyczno-Niepodległościowa „Wolność” - kierowana przez Wacława Zagórskiego, prof. Feliksa Grossa, redaktora Zbigniewa Mitznera i Tadeusza Zajączkowskiego.',
      'Akcja Ludowa - kierowana przez Jerzego Wrońskiego i ks. Henryka Hlebowicza.',
      'Organizacja Wojskowa Narodu Walczącego - kierowana przez Antoniego Anatola Rymaszewskiego „Andrzej”.',
      'Służba Zwycięstwu Polski - kierowana przez ppłk dypl. Nikodema Sulika „Ładyna”, „Jodko”.'
    ]
  },
  konsp_wladze:{
    list:[
      'ksiądz Kazimierz Kucharski „Szczepan”,',
      'ppłk Nikodem Sulik „Karol Sarnowski”, „Karol Jodko” i „Ładyna”.',
      'Bronisław Świątnicki „Ojciec”,',
      'kpt. Aleksander Wasilewski „Wład”, „Olesiński” w zastępstwie kpt. dypl. Antoniego Olechnowicza „Meteor”, „Pohorecki”.',
      'por. Julian Pietraszewski „Julian”.',
      'dr Jerzy Dobrzański „Maciej” z ramienia PPS-WRN.',
      'Witold Świerzewski „Bartek” z ramienia Stronnictwa Narodowego.',
      'Piotr Kownacki również ze Stronnictwa Narodowego.',
      'dwaj przedstawiciele Sanacji oraz drugi przedstawiciel PPS-WRN, których nazwisk nie udało się odtworzyć.'
    ]
  },
  zasady_dzialalnosci:{
    cards:[
      {
        id:0,
        img: '/historia/okres_39_41/Kazimierz_Kucharski.jpg',
        desc: 'Ks. Kazimierz Kucharski „Szczepan”'
      },
      {
        id:1,
        img: '/historia/okres_39_41/Aleksander_Wasile.jpg',
        desc: 'Kpt. Aleksander Wasilewski „Olesiński”'
      },
      {
        id:2,
        img: '/historia/okres_39_41/Antoni_Olechnowicz.jpg',
        desc: 'Kpt. dypl. Antoni Olechnowicz „Pohorecki”'
      },
      {
        id:3,
        img: '/historia/okres_39_41/Jerzy_Dobrzanski.jpg',
        desc: 'Dr Jerzy Dobrzański „Maciej"'
      }
    ],
    list:[
      'Wszyscy, bez względu na przynależność polityczną danej grupy, służymy jednej najważniejszej sprawie, jaką jest odzyskanie niepodległości.',
      'Od tej służby nie odsuwamy nikogo, kto po wypadkach wrześniowych niczym nie zhańbił swojej godności Polaka.',
      'Nie wskrzeszajmy przeszłości i obecnie nie będziemy robić z nią żadnych obrachunków.',
      'Sprawę przyszłego kształtu ustrojowego Polski, zostawiamy do rozstrzygnięcia po odzyskaniu niepodległości.',
    ]
  },
  komenda_wilno:{
    cards:[
      {
        id:0,
        img: '/historia/okres_39_41/Czeslaw_Debicki.jpg',
        desc: 'Mjr Czesław Dębicki „Jarema”'
      },
      {
        id:1,
        img: '/historia/okres_39_41/Stefan_Czernik.jpg',
        desc: 'Por. Stefan Czernik „Orwat”'
      },
      {
        id:2,
        img: '/historia/okres_39_41/Jerzy_Urbankiewicz.jpg',
        desc: 'Por Jerzy Urbankiewicz „Zawada”'
      },
      {
        id:3,
        img: '/historia/okres_39_41/Sergiusz_Zyndram_Koscialkowski.jpg',
        desc: 'Sergiusz Zyndram-Kościałkowski „Fakir”'
      }
    ],
    list:[
      'Komendant Okręgu - ppłk dypl. Nikodem Sulik „Karol Sarnowski”, „Karol Jodko”, „Ładyna”.',
      'Adiutant Komendanta Okręgu - por. Bolesław Wasilewski „Zosia”.',
      'Zastępca Komendanta Okręgu i szef sztabu - ppłk Adam Obtułowicz „Karol Podgórski”, „Leon”.',
      'Zastępca Komendanta d/s. Propagandy i Prasy - mjr rez. Władysław Kamiński „Śliwa”.',
      'Kwatermistrz - mjr Aleksander Krzyżanowski „Wesołowski”, „Dziemido”, „Wilk”.',
      'Szef Ogólnoorganizacyjny - kpt. dypl. Antoni Olechnowicz „Pohorecki”.',
      'Szef Wywiadu - ppłk dypl. Zygmunt Cetnerowski „Zygmunt”.',
      'Szef Łączności - por. Stefan Czernik „Orwat”.',
      'Przewodniczący Komisji Finansowej, Legalizacji, Sanitarnej oraz Spraw Młodzieży',
      'ks. Kazimierz Kucharski „Szczepan”.',
      'Komendant Garnizonu m. Wilna „Dwór” - kpt. Aleksander Wasilewski „Olesiński” oraz kpt. Karol Zieliński „Czerw”, „Tomczyk”, „Brzoza”.',
      'Komendant pozostałej części województwa „Pole”- mjr Józef Roczniak oraz kpt. inż. Czesław Dębicki „Jarema”.',
      'Wojskowy Sąd Specjalny - Stanisław Ochocki „Justyn”.',
      'Egzekutywa - por. Jerzy Urbankiewicz „Jurek”, Jarosław Skrodzki „Zeks”„',
      '„Sergiusz Zyndram-Kościałkowski „Lech”, „Fakir”'
    ]
  },
  rada_woj:{
    list:[
      'Przewodniczący - ppłk dypl. Nikodem Sulik „Karol Sarnowski”.',
      'Wiceprzewodniczący - mjr rez. Władysław Kamiński „Śliwa” i mjr Aleksander Krzyżanowski „Dziemido”.',
      'Przedstawiciel Kurii - ks. Romuald Świrkowski.',
      'Przedstawiciel PPS-WRN - dr Jerzy Dobrzański „Maciej”, „Irwid”.',
      'Przedstawiciel Stronnictwa Narodowego- mgr Witold Świerzewski „Bartek”.',
      'Przedstawiciel Sanacji - Adam Galiński „Adam” „Pan P”.',
      'Przedstawiciel Stronnictwa Ludowego od jesieni 1941 r. - prof. Ludwik Chmaj „Jaroński”.'
    ]
  },
  podokreg_kowienski:{
    list:[
      'Komendant - por. Zbigniew Jentys „Habdank”.',
      'Z- ca komendanta do spraw wojskowych - rtm Wincenty Chrząszczewski „Kruk”.',
      'Z- ca komendanta do spraw politycznych - Stanisław May „Dziadzio”.',
      'Szef Oddziału Organizacyjnego - Tadeusz Kognowicki „Złoty”.',
      'Szef Łączności Zewnętrznej - Stanisław Mikulicz, a następnie ppor. Eryk Budzyński „Brankard”.',
      'Kwatermistrz - Józef Majewski „Literat”.',
      'Szef Oddziału Propagandy i Prasy - Zygmunt Ugiański „Redaktor”.',
      'Komendant wojskowy miasta Kowna - por. Kazimierz Będzicha „Grzegorz”, „Jakub”.'
    ]
  },
  podokreg_obwody:{
    list:[
      'Obwód Kowno - Mieczysław Turkiewicz „Szofer”.',
      'Obwód Kiejdany - chor. Franciszek Madoński „Pochmurny”.',
      'Obwód Szawle -Teodor Magurski „Michał”.'
    ]
  },
  pion_podokreg_kowienski:{
    cards:[
      {
        id:0,
        img: '/historia/okres_39_41/Julian_Kulikowski.jpg',
        desc: 'Mjr dypl. Julian Kulikowski „Ryngraf”'
      },
      {
        id:1,
        img: '/historia/okres_39_41/Zbigniew_Jentys.jpg',
        desc: 'por. Zbigniew Jentys „Habdank”'
      },
      {
        id:2,
        img: '/historia/okres_39_41/Wincenty_Chrzaszczewski.jpg',
        desc: 'Rtm. Wincenty Chrząszczewski „Kruk”'
      },
      {
        id:3,
        img: '/historia/okres_39_41/Tadeusz_Kognowicki.jpg',
        desc: 'Tadeusz Kognowicki „Złoty”'
      },
      {
        id:4,
        img: '/historia/okres_39_41/Adam_Dowgird.jpg',
        desc: 'Dr Adam Dowgird „Dominik”'
      },
      {
        id:5,
        img: '/historia/okres_39_41/Zygmunt_Szczesny_Brzozowski.jpg',
        desc: 'Zygmunt Szczęsny-Brzozowski „Gustaw”'
      }
    ],
    list:[
      'Komendant - dr Adam Dowgird „Dominik”, „Florian”.',
      'Z- ca Komendanta do Spraw Cywilnych - Zygmunt Szczęsny- Brzozowski „Gustaw”.',
      'Z- ca Komendanta do Spraw Wojskowych - rtm. Wincenty Chrząszczewski „Kruk”.',
      'Szef Łączności - Hipolit Józef Mickiewicz „Adam”.',
      'Szef Wydziału Organizacyjnego - Piotr Gieduszko.',
      'Szef Komórki Informacji o Ruchu Litewskim - Gerard Knoch.',
      'Szef Łączności z Komendą Okręgu Wileńskiego - Joanna Niedziałkowska „Ewa”.'
    ]
  },
  inspektorat_e:{
    list:[
      'Inspektor - rtm. Wincenty Chrząszczewski „Kruk”.',
      'Adiutant Inspektora - ppor. Eryk Budzyński „Brankard”.',
      'Kwatermistrz - Jan Chmielewski „Ojciec”.',
      'Łącznicy Inspektora - Filomena Majerówna „Mała” i Julian Iwaszkiewicz „Ferdynand”.'
    ]
  }
}



// WEBPACK FOOTER //
// ./src/models/historia/okres_39_41.js